module.exports = __webpack_public_path__ + "img/cent-sign.01dbb671.svg";